(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-24ss-look"]) return;
  try {
    
var flgAutoplay = true;
var featCou;
var flgActFeatList = true;
var featTerm;
$(function(){

$(".look-slider-wrap").mouseover(function(e) {
  flgAutoplay = false;
}).mouseout(function(e) {
  flgAutoplay = true;
});

setFeatList($(".look-slider-wrap"));

featTerm = setInterval(function(){
  if(flgAutoplay){
    $(".look-slider-right").trigger("click");
  }
},4000);

 if ($(window).width() > 800){
      $(".look-slider-wrap").removeAttr("style");
   }else{
      $(".look-slider-wrap").css({"height":checkFeatHeight()+"px"});
   }
   $(window).resize(function() {
  if ($(window).width() > 800){
      $(".look-slider-wrap").removeAttr("style");
   }else{
      $(".look-slider-wrap").css({"height":checkFeatHeight()+"px"});
   }
   });
});
function checkFeatHeight(){
var hei=0;
$(".look-slider-list li").each(function(){
if($(this).height()>hei){
hei=$(this).height();
}
});
return hei;
}
function setFeatList(_t){
	featCou = _t.find(".look-slider-list li").length;
	if(featCou==1){
		$(".look-slider-left").css({"display":"none"});
		$(".look-slider-right").css({"display":"none"});
	}else{
		var i = 0;
	  _t.find(".look-slider-list li").each(function(){
			$(this).css({"left":-100 * (featCou - i) + "%"});
			$(this).clone().css({"left":100 * i + "%"}).appendTo(_t.find(".look-slider-list"));
			if(i==0){
				_t.find(".look-slider-cur-list").append('<li class="act"></li>');
			}else{
				_t.find(".look-slider-cur-list").append('<li></li>');
			}
			i = i + 1;
		});
	  _t.find(".look-slider-cur-list li").each(function(){
			$(this).click(function() {
				var idxCur = _t.find(".look-slider-cur-list li").index($(this));
				var actCur = _t.find(".look-slider-cur-list li").index(_t.find(".look-slider-cur-list li.act"));
				actFeatList($(this).parents(".look-slider-wrap"),idxCur-actCur,500);
			});
		});
		_t.find(".look-slider-left").click(function(){
			actFeatList($(this).parents(".look-slider-wrap"),-1,500);
		});
		_t.find(".look-slider-right").click(function(){
			actFeatList($(this).parents(".look-slider-wrap"),1,500);
		});
		_t.find(".look-slider-list").bind({
				"touchstart": function(e) {
					this.touchX = event.changedTouches[0].pageX;
					this.slideX = $(this).position().left;
					startPos = $(this).position().left;
				},
				"touchmove": function(e) {
					var moveX = this.touchX - event.changedTouches[0].pageX;
					var moveY = this.touchY - event.changedTouches[0].pageY;
					var moveRate = moveX / moveY;
					if(moveRate > Math.tan(15 * Math.PI/180)){
					e.preventDefault();
					}
					this.slideX = this.slideX-(this.touchX-event.changedTouches[0].pageX);
					$(this).css({left:this.slideX});
					this.touchX = event.changedTouches[0].pageX;
				},
				"touchend": function(e) {
					var add=0;
					var end = $(this).position().left;
					if(end - startPos < -50){
						add = 1;
					}else if(end - startPos > 50){
						add = -1;
					}
					if(add==0){
						$(this).stop().animate({left:0},{duration:"normal",complete:function(){
						}});
					}else{
						$(this).stop().animate({left:0},{duration:"normal",complete:function(){
						}});
						actFeatList($(this).parent(),add,500);
					}
				}
		});
	}
}
function actFeatList(_t,_n,_d){
	if(flgActFeatList == true){
		if(_n == 0){
		}else if(_n > 0){
			flgActFeatList = false;
			var idxCur = _t.find(".look-slider-cur-list li").index(_t.find(".look-slider-cur-list li.act"));
			_t.find(".look-slider-cur-list li").removeClass("act");
			if( idxCur+_n >= featCou){
				_t.find(".look-slider-cur-list li").eq(idxCur+_n-featCou).addClass("act");
			}else{
				_t.find(".look-slider-cur-list li").eq(idxCur+_n).addClass("act");
			}
			for (var i = 0;i < Math.abs(_n);i++){
				_t.find(".look-slider-list li").eq(i).clone().appendTo(_t.find(".look-slider-list"));
				var pos_left = (_t.find(".look-slider-list li").length - featCou - 1) * 100 + "%";
				_t.find(".look-slider-list li").filter(":last").css({"left":pos_left});
			}
			var num_act = _t.find(".look-slider-list li").length;
			var cou_act = 0 ;
			_t.find(".look-slider-list li").each(function(i,elem){
				$(this).stop().animate({left: "-="+( Math.abs(_n) * 100)+"%" },{duration:_d,complete:function(){
					cou_act++
					if(num_act==cou_act){
						for (var i=0;i<Math.abs(_n);i++){
								_t.find(".look-slider-list li").filter(":first").remove();
						}
						flgActFeatList = true;
					}
				}});
			});
		}else if(_n < 0){
			flgActFeatList = false;
			var idxCur = _t.find(".look-slider-cur-list li").index(_t.find(".look-slider-cur-list li.act"));
			_t.find(".look-slider-cur-list li").removeClass("act");
			if( idxCur+_n < 0){
				_t.find(".look-slider-cur-list li").eq(featCou+idxCur+_n).addClass("act");
			}else{
				_t.find(".look-slider-cur-list li").eq(idxCur+_n).addClass("act");
			}
			for (var i=0;i<Math.abs(_n);i++){
				_t.find(".look-slider-list li").last(1+i).clone().prependTo(_t.find(".look-slider-list"));
				var pos_left = (_t.find(".look-slider-list li").length - featCou) * -1 * 100 + "%";
				_t.find(".look-slider-list li").filter(":first").css({"left":pos_left});
			}
			var num_act = _t.find(".look-slider-list li").length;
			var cou_act = 0 ;
			_t.find(".look-slider-list li").each(function(i,elem){
				$(this).stop().animate({left: "+="+( Math.abs(_n) * 100)+"%" },{duration:_d,complete:function(){
					cou_act++
					if(num_act==cou_act){
						in_flg = true;
						for (var i=0;i<Math.abs(_n);i++){
								_t.find(".look-slider-list li").filter(":last").remove();
						}
						flgActFeatList = true;
					}
				}});
			});
		}
	}
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-feature-index"]) return;
  try {
    
var featCou;
var flgActFeatList = true;
var featTerm;
$(function(){
  setFeatList($(".feature-slider-wrap"));
  /*  
  featTerm = setInterval(function(){
  $(".feature-slider-right").trigger("click");
  },4000);
  */  
 if ($(window).width() > 1000){
      $(".feature-slider-wrap").removeAttr("style");
   }else{
      $(".feature-slider-wrap").css({"height":checkFeatHeight()+"px"});
   }
   $(window).resize(function() {
  if ($(window).width() > 1000){
      $(".feature-slider-wrap").removeAttr("style");
   }else{
      $(".feature-slider-wrap").css({"height":checkFeatHeight()+"px"});
   }
   });
});
function checkFeatHeight(){
var hei=0;
$(".feature-slider-list li").each(function(){
if($(this).height()>hei){
hei=$(this).height();
}
});
return hei;
}
function setFeatList(_t){
	featCou = _t.find(".feature-slider-list li").length;
	if(featCou==1){
		$(".feature-slider-left").css({"display":"none"});
		$(".feature-slider-right").css({"display":"none"});
	}else{
		var i = 0;
	  _t.find(".feature-slider-list li").each(function(){
			$(this).css({"left":-100 * (featCou - i) + "%"});
			$(this).clone().css({"left":100 * i + "%"}).appendTo(_t.find(".feature-slider-list"));
			if(i==0){
				_t.find(".feature-slider-cur-list").append('<li class="act"></li>');
			}else{
				_t.find(".feature-slider-cur-list").append('<li></li>');
			}
			i = i + 1;
		});
	  _t.find(".feature-slider-cur-list li").each(function(){
			$(this).click(function() {
				var idxCur = _t.find(".feature-slider-cur-list li").index($(this));
				var actCur = _t.find(".feature-slider-cur-list li").index(_t.find(".feature-slider-cur-list li.act"));
				actFeatList($(this).parents(".feature-slider-wrap"),idxCur-actCur,500);
			});
		});
		_t.find(".feature-slider-left").click(function(){
			actFeatList($(this).parents(".feature-slider-wrap"),-1,500);
		});
		_t.find(".feature-slider-right").click(function(){
			actFeatList($(this).parents(".feature-slider-wrap"),1,500);
		});
		_t.find(".feature-slider-list").bind({
				"touchstart": function(e) {
					this.touchX = event.changedTouches[0].pageX;
					this.slideX = $(this).position().left;
					startPos = $(this).position().left;
				},
				"touchmove": function(e) {
					var moveX = this.touchX - event.changedTouches[0].pageX;
					var moveY = this.touchY - event.changedTouches[0].pageY;
					var moveRate = moveX / moveY;
					if(moveRate > Math.tan(15 * Math.PI/180)){
					e.preventDefault();
					}
					this.slideX = this.slideX-(this.touchX-event.changedTouches[0].pageX);
					$(this).css({left:this.slideX});
					this.touchX = event.changedTouches[0].pageX;
				},
				"touchend": function(e) {
					var add=0;
					var end = $(this).position().left;
					if(end - startPos < -50){
						add = 1;
					}else if(end - startPos > 50){
						add = -1;
					}
					if(add==0){
						$(this).stop().animate({left:0},{duration:"normal",complete:function(){
						}});
					}else{
						$(this).stop().animate({left:0},{duration:"normal",complete:function(){
						}});
						actFeatList($(this).parent(),add,500);
					}
				}
		});
	}
}
function actFeatList(_t,_n,_d){
	if(flgActFeatList == true){
		if(_n == 0){
		}else if(_n > 0){
			flgActFeatList = false;
			var idxCur = _t.find(".feature-slider-cur-list li").index(_t.find(".feature-slider-cur-list li.act"));
			_t.find(".feature-slider-cur-list li").removeClass("act");
			if( idxCur+_n >= featCou){
				_t.find(".feature-slider-cur-list li").eq(idxCur+_n-featCou).addClass("act");
			}else{
				_t.find(".feature-slider-cur-list li").eq(idxCur+_n).addClass("act");
			}
			for (var i = 0;i < Math.abs(_n);i++){
				_t.find(".feature-slider-list li").eq(i).clone().appendTo(_t.find(".feature-slider-list"));
				var pos_left = (_t.find(".feature-slider-list li").length - featCou - 1) * 100 + "%";
				_t.find(".feature-slider-list li").filter(":last").css({"left":pos_left});
			}
			var num_act = _t.find(".feature-slider-list li").length;
			var cou_act = 0 ;
			_t.find(".feature-slider-list li").each(function(i,elem){
				$(this).stop().animate({left: "-="+( Math.abs(_n) * 100)+"%" },{duration:_d,complete:function(){
					cou_act++
					if(num_act==cou_act){
						for (var i=0;i<Math.abs(_n);i++){
								_t.find(".feature-slider-list li").filter(":first").remove();
						}
						flgActFeatList = true;
					}
				}});
			});
		}else if(_n < 0){
			flgActFeatList = false;
			var idxCur = _t.find(".feature-slider-cur-list li").index(_t.find(".feature-slider-cur-list li.act"));
			_t.find(".feature-slider-cur-list li").removeClass("act");
			if( idxCur+_n < 0){
				_t.find(".feature-slider-cur-list li").eq(featCou+idxCur+_n).addClass("act");
			}else{
				_t.find(".feature-slider-cur-list li").eq(idxCur+_n).addClass("act");
			}
			for (var i=0;i<Math.abs(_n);i++){
				_t.find(".feature-slider-list li").last(1+i).clone().prependTo(_t.find(".feature-slider-list"));
				var pos_left = (_t.find(".feature-slider-list li").length - featCou) * -1 * 100 + "%";
				_t.find(".feature-slider-list li").filter(":first").css({"left":pos_left});
			}
			var num_act = _t.find(".feature-slider-list li").length;
			var cou_act = 0 ;
			_t.find(".feature-slider-list li").each(function(i,elem){
				$(this).stop().animate({left: "+="+( Math.abs(_n) * 100)+"%" },{duration:_d,complete:function(){
					cou_act++
					if(num_act==cou_act){
						for (var i=0;i<Math.abs(_n);i++){
								_t.find(".feature-slider-list li").filter(":last").remove();
						}
						flgActFeatList = true;
					}
				}});
			});
		}
	}
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-information"]) return;
  try {
    
$(function(){
$(".flash-list li").click(function() {
if($(this).hasClass("open")){
$(this).removeClass("open");
}else{
$(this).addClass("open");
}
$(this).find(".flash-list-text").slideToggle(300);
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-intro-23aw"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function(){
  setTopIntro();
});

function getCookie(_n) {
    var result = null;
    var cookieName = _n + '=';
    var allcookies = document.cookie;
    var position = allcookies.indexOf(cookieName);
    if (position != -1) {
        var startIndex = position + cookieName.length;
        var endIndex = allcookies.indexOf(';', startIndex);
        if (endIndex == -1) {
            endIndex = allcookies.length;
        }
        result = decodeURIComponent(
            allcookies.substring(startIndex, endIndex));
    }
    return result;
}

function setTopIntro(){
    //if(getCookie("intro")!="true"){
    if (getCookie("intro") != "false") {
      $("#top-intro-23aw").css({"display":"block"});
      $(".top-intro-23aw-inner").delay(400).animate({opacity:1,top:"50%"},{
        duration:800,
        easing:"swing",
        complete:function(){
           $(".top-intro-23aw-inner").delay(1500).animate({opacity:0,top:"45%"},{
              duration:800,
              easing:"swing",
              complete:function(){
                $("#top-intro-23aw").delay(400).animate({opacity:0},{
                    duration:800,
                    easing:"swing",
                    complete:function(){
                        $("#top-intro-23aw").css({"display":"none"});
                        var date;
                        var term = 1;
                        date = new Date();
                        date.setTime(date.getTime() + term * 24 * 60 * 60 * 1000);
                        date = date.toGMTString();
                        document.cookie = "intro=false;expires=" + date;
                    }
                });
              }
          });
        }
      });
    }else{
        $("#top-intro-23aw").css({"display":"none"});
    }
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-intro"]) return;
  try {
    
$(function(){
  setTopIntro();
});
function getCookie(_n) {
    var result = null;
    var cookieName = _n + '=';
    var allcookies = document.cookie;
    var position = allcookies.indexOf(cookieName);
    if (position != -1) {
        var startIndex = position + cookieName.length;
        var endIndex = allcookies.indexOf(';', startIndex);
        if (endIndex == -1) {
            endIndex = allcookies.length;
        }
        result = decodeURIComponent(
            allcookies.substring(startIndex, endIndex));
    }
    return result;
}  
function setTopIntro() {
    //if(getCookie("intro")!="true"){
    if (getCookie("intro") != "false") {
        $("#top-intro").css({ "display": "block" });
        $(".top-intro-inner").delay(1500).animate({ opacity: 0 }, {
            duration: "slow",
            complete: function() {
                $("#top-intro").delay(400).animate({ opacity: 0 }, {
                    duration: "slow",
                    complete: function() {
                        $("#top-intro").css({ "display": "none" });
                        var date;
                        var term = 1;
                        date = new Date();
                        date.setTime(date.getTime() + term * 24 * 60 * 60 * 1000);
                        date = date.toGMTString();
                        document.cookie = "intro=false;expires=" + date;
                    }
                });
            }
        });
    } else {
        $("#top-intro").css({ "display": "none" });
    }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-main-visual-full"]) return;
  try {
    
var ua = navigator.userAgent;
var uaPad = window.navigator.userAgent.toLowerCase();
var touchEvent = window.ontouchstart;
var touchPoints = navigator.maxTouchPoints;
var mainVisualScroll;
if (ua.indexOf("iPhone") > 0 || ua.indexOf("iPod") > 0 || ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) {
    ua = "sp";
} else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
    ua = "tab";
} else {
    ua = "pc";
}
if (uaPad.indexOf("ipad") > -1 || uaPad.indexOf("macintosh") > -1 && "ontouchend" in document) {
    ua = "tab";
}
$(function() {
  /*
  var randomClass = Math.random() < 0.5 ? "image01" : "image02";
  $("#top-visual-full").addClass(randomClass);
  */
  $(".top-visual-scroll").click(function(){
        $("html, body").animate({scrollTop:$(".top-visual.top-visual-full").outerHeight()},600,"swing");
  });
  $(".top-visual").on("inview", function() {
        $(this).addClass("inview");
  });
  mainVisualScroll = $(window).scrollTop();
  if(mainVisualScroll>$(".top-visual.top-visual-full").outerHeight()){
    $("#header").removeClass("header--white");
  }else{
    $("#header").addClass("header--white");
  }
  $(window).scroll(function() {
    mainVisualScroll = $(window).scrollTop();
    if(mainVisualScroll>$(".top-visual.top-visual-full").outerHeight()){
      $("#header").removeClass("header--white");
    }else{
      $("#header").addClass("header--white");
    }
  });
  if( touchEvent !== undefined && 0 < touchPoints ) {
    $(".category-nav ul").bind({
         "touchstart": function(e) {
           if(mainVisualScroll>$(".top-visual.top-visual-full").outerHeight()){
             $("#header").removeClass("header--white");
           }else{
             $("#header").addClass("header--white");
           }
         },
         "touchmove": function(e) {
         },
         "touchend": function(e) {
           if(mainVisualScroll>$(".top-visual.top-visual-full").outerHeight()){
             $("#header").removeClass("header--white");
           }else{
             $("#header").addClass("header--white");
           }
         }
     });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-main-visual"]) return;
  try {
    

var termMainVis;
var termMainVisBar;
var termMainVisBarSp;

document.addEventListener("DOMContentLoaded", function(){
  //if (getCookie("intro") != "true") {
  if (getCookie("intro") != "false") {
    setTimeout(setMainVisual,3000);
  }else{
    setMainVisual();
  }

});

function getCookie(_n) {
    var result = null;
    var cookieName = _n + '=';
    var allcookies = document.cookie;
    var position = allcookies.indexOf(cookieName);
    if (position != -1) {
        var startIndex = position + cookieName.length;
        var endIndex = allcookies.indexOf(';', startIndex);
        if (endIndex == -1) {
            endIndex = allcookies.length;
        }
        result = decodeURIComponent(
            allcookies.substring(startIndex, endIndex));
    }
    return result;
}

function setMainVisual(){
    $(".top-visual-title-btn a").each(function(idx,ele){
      var href=$(this).attr("href");
      if(href.charAt(0)=="#"){
        $(this).click(function(){
          var speed = 500;
          var target = $(href == "#" || href == "" ? "html" : href);
          var position = target.offset().top;
          if(window.innerWidth > 900){
            position-=120;
          }else{
            position-=60;
          }
          $("html,body").animate({scrollTop:position}, speed, "swing");
          return false;
        });
      }
    });
    $(".top-visual-title-s,.top-visual-title-l,.top-visual-title-date").each(function(idx,ele) {
      var text_temp = $(this).text();
      $(this).empty();
      //$(this).append('<span class="word-wrap delay'+ idx +'"><span class="word-child">' + text_temp + '</span></span>');
      $(this).append('<span class="word-wrap"><span class="word-child">' + text_temp + '</span></span>');
    });
    var max = 0;
    if(String($(".top-visual-list li").length).length == 1){
      max = "0" + String($(".top-visual-list li").length);
    }else{
      max = String($(".top-visual-list li").length);
    }
    $(".top-visual-list li").each(function(idx,ele){
      $(this).attr("data-number",idx + 1);
    });
    $(".top-visual-ctrl-max").html(max);
    $(".top-visual-ctrl-max-sp").html(max);
    $(".top-visual-list li").eq(0).addClass("img-fv").addClass("act").appendTo(".top-visual-list");
    chaMainVisual();
    termMainVis = setInterval(function(){
        chaMainVisualAuto();
    },6000);
    setTimeout(function(){
      $(".top-visual").removeClass("inview");
    },300);
    $(".top-visual-ctrl-l").click(function(){
      if($(".top-visual-list li").eq($(".top-visual-list li").length-1).find(".top-visual-img").is(":animated")==false){
        chaMainVisualLeft();
      };
    });
    $(".top-visual-ctrl-r").click(function(){
      if($(".top-visual-list li").eq($(".top-visual-list li").length-1).find(".top-visual-img").is(":animated")==false){
        chaMainVisualRight();
      };
    });
    sizeMainVisual();
    $(window).resize(function(){
    	sizeMainVisual();
    });
}

function chaMainVisualLeft(){
  clearInterval(termMainVis);
  $(".top-visual-list li").removeClass("act");
  $(".top-visual-list li").find(".top-visual-img").removeAttr("style");
  $(".top-visual-list li").eq(-2).removeClass("img-act").removeClass("img-fv");
  $(".top-visual-list li").eq(-2).queue(function () {
    $(".top-visual-list li").eq(-2).addClass("img-act").dequeue();
  });
  $(".top-visual-list li").eq(-1).find(".top-visual-img").stop().animate({opacity:0},{
    duration:"1200",
    easing:"linear",
    complete:function(){
       $(".top-visual-list li").eq(-1).prependTo(".top-visual-list");
       $(".top-visual-list li").eq(0).find(".top-visual-img").removeAttr("style");
       $(".top-visual-list li").eq(-1).addClass("act");
       chaMainVisual();
       termMainVis = setInterval(function(){
          chaMainVisualAuto();
       },6000);
    }
  });
  /*
  clearInterval(termMainVis);
  $(".top-visual-list li").removeClass("act");
  $(".top-visual-list li").eq($(".top-visual-list li").length-2).addClass("img-act");
  $(".top-visual-list li").eq($(".top-visual-list li").length-1).find(".top-visual-img").stop().animate({opacity:0},{
    duration:"1200",
    easing:"linear",
    complete:function(){
       $(".top-visual-list li").eq($(".top-visual-list li").length-1).removeClass("img-act").removeClass("img-fv").prependTo(".top-visual-list");
       $(".top-visual-list li").eq(0).find(".top-visual-img").removeAttr("style");
       $(".top-visual-list li").eq($(".top-visual-list li").length-1).addClass("act");
       chaMainVisual();
       termMainVis = setInterval(function(){
          chaMainVisualAuto();
       },6000);
    }
  });
  */
};

function chaMainVisualRight(){
  clearInterval(termMainVis);
  $(".top-visual-list li").removeClass("act");
  $(".top-visual-list li").eq(0).find(".top-visual-img").css({"opacity":"0"});
  $(".top-visual-list li").eq(0).removeClass("img-act").removeClass("img-fv").appendTo(".top-visual-list");
  $(".top-visual-list li").eq($(".top-visual-list li").length-1).find(".top-visual-img").stop().animate({opacity:1},{duration:"1200",easing:"linear"});
  $(".top-visual-list li").eq($(".top-visual-list li").length-1).addClass("act").addClass("img-act");
  chaMainVisual();
  termMainVis = setInterval(function(){
    chaMainVisualAuto();
  },6000);
};

function chaMainVisualAuto(){
  $(".top-visual-list li").removeClass("act");
  $(".top-visual-list li").eq(0).find(".top-visual-img").css({"opacity":"0"});
  $(".top-visual-list li").eq(0).removeClass("img-act").removeClass("img-fv").appendTo(".top-visual-list");
  $(".top-visual-list li").eq($(".top-visual-list li").length-1).find(".top-visual-img").stop().animate({opacity:1},{duration:"1200",easing:"linear"});
  $(".top-visual-list li").eq($(".top-visual-list li").length-1).addClass("act").addClass("img-act");
  chaMainVisual();
};

function chaMainVisual(){
  var min = 0;
  if(String($(".top-visual-list li.act").attr("data-number")).length == 1){
    min = "0" + String($(".top-visual-list li.act").attr("data-number"));
  }else{
    min = String($(".top-visual-list li.act").attr("data-number"));
  }
  $(".top-visual-ctrl-min").html(min);
  $(".top-visual-ctrl-min-sp").html(min);
  $(".top-visual-ctrl-bar-act").stop().css({"width":"0"}).animate({"width":"100%"},6000,"linear");
  $(".top-visual-ctrl-bar-act-sp").stop().css({"height":"0"}).animate({"height":"100%"},6000,"linear");
};

function sizeMainVisual(){
  if (window.innerWidth > 900){
    $(".top-visual").removeAttr("style");
  }else{
    var hei = 0;
    $(".top-visual-list li").each(function(idx,ele){
      if(hei<$(this).height()){
        hei= $(this).height();
      }
    });
    $(".top-visual").css({ "height":hei+"px" });
  }
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-movie"]) return;
  try {
    
$(function(){
setTopMovie();
});
function setTopMovie(){
$(".top-movie-thumb").click(function(){
$(this).addClass("nowplay");
var src = $(this).attr("data-movie");
$(".top-movie-thumb").each(function() {
$(this).find("video")[0].pause();
});
$("body").append('<div class="top-movie-modal"><div class="top-movie-modal-close"><div class="top-movie-modal-close-ico"></div></div><div class="top-movie-modal-box"><div class="top-movie-modal-box-inner"><iframe src="'+src+'?autoplay=1" frameborder="0" allow="autoplay;fullscreen;picture-in-picture" allowfullscreen></iframe></div></div></div>');
$(".top-movie-modal").css({"display":"block"});
$(".top-movie-modal").stop().animate({opacity:1},500,function(){
$(".top-movie-modal-close").click(function(){
$(".top-movie-thumb").each(function() {
$(this).find("video")[0].play();
});
$(".top-movie-modal").stop().animate({opacity:0},500,function(){
$(".top-movie-modal").remove();
$(".nowplay").removeClass("nowplay");
});
});
});
});
}

  } catch(e) { console.error(e); }
})();
})();
